if (!customElements.get('video-wrapper')) {
  customElements.define(
    'video-wrapper',
    class VideoWrapper extends HTMLElement {
      constructor() {
        super();
        this.playVideos();
      }

      playVideos() {
        const videos = document.querySelectorAll(
          '.video-bg__media video'
        );

        if (!videos) {
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play();
              } else {
                entry.target.pause();
              }
            });
          },
          {
            threshold: 0.25,
          }
        );

        videos.forEach((video) => {
          observer.observe(video);
        });
      }
    }
  );
}
